/**
 * `URL.parse` is a 2024 static method — Chrome 126, Firefox 126, Safari 18.4.
 * pdfjs-dist 5.x calls it in six places in `build/pdf.mjs` with no fallback, so
 * on anything older every PDF throws `URL.parse is not a function` and the
 * viewer never renders. That reaches resume preview, chat attachments, project
 * files and the bug-report dialog — and a good share of our traffic is older
 * Android WebViews, which are exactly the clients that lack it.
 *
 * Imported first from src/index.tsx: ES imports are hoisted, so a statement in
 * the same module would run after pdfjs had already been evaluated.
 */
type UrlParse = (url: string | URL, base?: string | URL) => URL | null;

if (typeof (URL as unknown as { parse?: UrlParse }).parse !== 'function') {
  (URL as unknown as { parse: UrlParse }).parse = (url, base) => {
    try {
      return base === undefined ? new URL(url) : new URL(url, base);
    } catch {
      // The spec's contract: invalid input resolves to null, never throws.
      return null;
    }
  };
}

export {};
